module.exports = __webpack_public_path__ + "static/img/testenvlogo.50f793c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testenvlogo.png
// module id = 3Xgp
// module chunks = 0